<template>
    <div class="animated fadeIn">
        <div>
            <b-row v-if="loading">
                <b-col cols="12" md="6">
                    <atom-spinner
                        :animation-duration="1000"
                        :size="60"
                        color="#ff1d5e"
                        class="float-right my-4"
                    />
                </b-col>
            </b-row>
        </div>
        <div v-if="!loading">
            <b-row>
                <b-col cols="12">
                    <h3>Commission Report</h3>
                </b-col>
            </b-row>
            <b-card>
                <b-row>
                    <b-col cols="12">
                        <b-row class="align-items-center">
                            <b-col cols="12" sm="7" md="8">
                                <h3 class="head-text mb-2 mb-sm-0">
                                    Commission Dashboard
                                </h3>
                            </b-col>

                            <b-col
                                cols="12"
                                sm="5"
                                md="3"
                                class="mt-2 mt-sm-0 ml-auto"
                            >
                                <eb-select
                                    ref="dateFilterRef"
                                    class="select-background-white"
                                    id="text"
                                    type="text"
                                    label="text"
                                    :options="dayOptions"
                                    v-model="selectedDate"
                                    :selected="selectedDate.text"
                                    @input="changeDateFilter"
                                ></eb-select>

                                <c-date
                                    ref="compRef"
                                    modalRef="modalRef"
                                    modalId="dateModal"
                                    @customDateRange="findCustomDate"
                                ></c-date>
                            </b-col>
                        </b-row>

                        <b-row class="mt-3">
                            <b-col sm="6" md="4" lg="3" class="mb-3">
                                <dashboardInfoCard
                                    labelText="Total Commission Value"
                                    :value="`${currencySymbol} ${totalCommission}`"
                                    bottomColor="#2c7df7"
                                />
                            </b-col>
                            <b-col sm="6" md="4" lg="3" class="mb-3">
                                <dashboardInfoCard
                                    labelText="Total Order Value"
                                    :value="`${currencySymbol} ${orderValue}`"
                                    bottomColor="#ffaf37"
                                />
                            </b-col>
                            <b-col sm="6" md="4" lg="3" class="mb-3">
                                <dashboardInfoCard
                                    labelText="No of Order"
                                    :value="orderCount"
                                    bottomColor="#42b039"
                                />
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-card>

            <b-row class="mt-3 align-items-center">
                <b-col cols="12" md="9" class="mb-2 mb-md-0">
                    <h4>Collected Commission VS Order Value</h4>
                </b-col>

                <b-col cols="12" md="3">
                    <eb-select
                        ref="dateFilterRef1"
                        class="select-background-white"
                        id="text"
                        type="text"
                        label="text"
                        :options="dayOptions"
                        v-model="selectedDate1"
                        :selected="selectedDate1.text"
                        @input="changeDateFilter1"
                    ></eb-select>

                    <c-date
                        ref="compRef1"
                        modalRef="modalRef1"
                        modalId="dateModal1"
                        @customDateRange="findCustomDate1"
                    ></c-date>
                </b-col>
            </b-row>

            <b-row class="mb-3">
                <b-col cols="12">
                    <b-card class="mt-0">
                        <div class="chart-container">
                            <BarChart
                                :chart-data="chartData"
                                :chart-options="barChartOptions"
                            />
                        </div>
                    </b-card>
                </b-col>
            </b-row>

            <b-row class="align-items-center mb-3">
                <b-col cols="12" md="6" class="mb-2 mb-md-0">
                    <h4>Seller Wise Commission Report</h4>
                </b-col>

                <b-col cols="12" sm="6" md="3" class="mb-2 mb-md-0">
                    <eb-select
                        class="select-background-white"
                        id="text"
                        type="text"
                        label="text"
                        :options="sellerList"
                        v-model="selectedSeller"
                        :selected="selectedSeller.text"
                        placeholder="Select Seller"
                        @input="fetchSellerWiseCommission"
                    >
                    </eb-select>
                </b-col>

                <b-col cols="12" sm="6" md="3">
                    <eb-select
                        ref="dateFilterRef2"
                        class="select-background-white"
                        id="text"
                        type="text"
                        label="text"
                        :options="dayOptions"
                        v-model="selectedDate2"
                        :selected="selectedDate2.text"
                        @input="changeDateFilter2"
                    >
                    </eb-select>

                    <c-date
                        ref="compRef2"
                        modalRef="modalRef2"
                        modalId="dateModal2"
                        @customDateRange="findCustomDate2"
                    ></c-date>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="12">
                    <b-card class="mt-0">
                        <b-table
                            hover
                            bordered
                            small
                            responsive
                            :items="tableData"
                            :fields="fields"
                            thead-class="header"
                            :current-page="currentPage"
                            :per-page="perPage"
                            :filter="filter"
                            @filtered="onFilter"
                            show-empty
                            :busy="loading"
                        >
                            <template #cell(action)="data">
                                <b-button
                                    variant="primary"
                                    @click="viewDetails(data.item)"
                                >
                                    View Detail
                                </b-button>
                            </template>
                        </b-table>

                        <div class="d-flex justify-content-end mt-2">
                            <b-pagination
                                align="right"
                                v-model="currentPage"
                                :per-page="perPage"
                                :total-rows="filterCount"
                                aria-controls="my-table"
                                prev-text="Prev"
                                next-text="Next"
                                hide-goto-end-buttons
                            ></b-pagination>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import ebSelect from "@/components/FormElements/Select.vue";
import cDate from "@/components/FormElements/CustomDate.vue";
import BarChart from "@/components/chart/BarChart";
import dashboardInfoCard from "@/components/Generics/dashboardInfoCard.vue";
import moment from "moment/moment";
import { mapState } from "vuex";
import commissionVsOrderValueGraph from "@/utils/commissionVsOrderValueGraph";
import { AtomSpinner } from "epic-spinners";

export default {
    name: "Reports",
    components: {
        ebSelect,
        cDate,
        BarChart,
        dashboardInfoCard,
        AtomSpinner,
    },
    data() {
        return {
            prevSelectedDate: null,
            prevSelectedDate1: null,
            prevSelectedDate2: null,
            loading: false,
            perPage: 10,
            currentPage: 1,
            filterCount: 0,
            filter: "",
            totalCommission: 0,
            orderCount: 0,
            orderValue: 0,
            cFromDate: "",
            cToDate: "",
            dayOptions: [
                {
                    text: "Today",
                    value: 0,
                },
                {
                    text: "7 days",
                    value: 6,
                },
                {
                    text: "30 days",
                    value: 29,
                },
                {
                    text: "Custom",
                    value: "Custom",
                },
            ],
            selectedDate: {
                text: "Today",
                value: 0,
            },
            selectedDate1: {
                text: "Today",
                value: 0,
            },
            selectedDate2: {
                text: "Today",
                value: 0,
            },
            selectedSeller: { text: "All Seller", value: "All Seller" },
            fields: [
                {
                    key: "sellerName",
                },
                {
                    key: "email",
                },
                {
                    key: "month",
                },
                {
                    key: "commission",
                },
                {
                    key: "walletAmount",
                },
                {
                    key: "totalOrderAmount",
                },
                {
                    key: "action",
                },
            ],
            items: [],
        };
    },
    computed: {
        ...mapState({
            commissionVsOrderGraph: (state) => state.partner.chartData,
            partnerList: (state) => state.partner.partnerList,
        }),
        userId() {
            if (this.$store.getters["auth/getUserID"]) {
                return this.$store.getters["auth/getUserID"];
            } else {
                return JSON.parse(sessionStorage.getItem("userLogin"))["_id"];
            }
        },
        currencySymbol() {
            const tenantPreferences =
                this.$store.getters["tenant/GetTenantPreferences"];
            return tenantPreferences?.currency?.symbol || "रु";
        },
        sellerList() {
            let sellerList = [{ text: "All Seller", value: "All Seller" }];
            this.partnerList.forEach((el) => {
                if (el.category == "SELLER") {
                    let obj = {
                        text: el.authentication.userName,
                        value: el._id,
                    };
                    sellerList.push(obj);
                }
            });
            return sellerList;
        },
        tableData() {
            let data = [];
            if (this.items?.length > 0) {
                this.items.forEach((item) => {
                    let obj = {
                        sellerName: item.name,
                        email: item.email,
                        month:
                            `${moment()
                                .month(item.month - 1)
                                .format("MMM")}` +
                            "-" +
                            `${item.year.toString().slice(-2)}`,
                        commission: Math.abs(
                            Math.trunc(Number(item.commission)),
                        ),
                        walletAmount: Math.trunc(Number(item["wallet_amount"])),
                        totalOrderAmount: Math.trunc(
                            Number(item["order_amount"]),
                        ),
                    };
                    data.push(obj);
                });
            }
            return data;
        },
        chartData() {
            const data = this.commissionVsOrderGraph;

            let orderArr = [];

            if (data["total-order-value-graph"]?.length) {
                data["total-order-value-graph"].forEach((el) => {
                    let obj = {
                        date: `${el.day}/${el.month}/${el.year}`,
                        ordervalue: el["total_order_value"],
                    };
                    orderArr.push(obj);
                });
            }

            let commissionObj = {};
            if (data["total-collected-commission-graph"]?.length) {
                data["total-collected-commission-graph"].forEach((el) => {
                    commissionObj[`${el.day}/${el.month}/${el.year}`] = {
                        commissionValue: el.amount,
                    };
                });
            }

            let arr = [];
            if (orderArr?.length) {
                orderArr.forEach((el) => {
                    let obj = {
                        ...el,
                        commissionValue: commissionObj[el.date]
                            ? commissionObj[el.date]
                            : 0,
                    };
                    arr.push(obj);
                });
            }

            let commissionData = "";
            let orderValueData = "";
            if (this.$currentUserData.category == "TA") {
                commissionData = "commissionValue";
                orderValueData = "ordervalue";
            }
            return commissionVsOrderValueGraph(
                arr,
                commissionData,
                orderValueData,
            );
        },
        barChartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        display: true,
                        beginAtZero: true,
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                        ticks: {
                            callback: function (value) {
                                const valueLegend =
                                    this.getLabelForValue(value);
                                const valueLegendRep = valueLegend.replaceAll(
                                    ",",
                                    "",
                                );
                                if (Number(valueLegendRep) < 2) {
                                    return valueLegendRep * 10;
                                } else {
                                    const valueShort =
                                        Number(valueLegendRep) / 1000;
                                    return valueShort + " " + "k";
                                }
                            },
                        },
                    },
                    x: {
                        display: true,
                        ticks: {
                            display: true,
                        },
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                },
            };
        },
    },
    methods: {
        viewDetails(data) {
            // this.$router.push({ name: "Seller Commission" });
        },
        onFilter(list) {
            this.filterCount = list?.length;
            this.currentPage = 1;
        },
        changeDateFilter(e) {
            if (e.value === "Custom") {
                this.prevSelectedDate = { ...this.selectedDate };
                this.selectedDate = this.prevSelectedDate;
                this.$nextTick(() => {
                    if (
                        this.$refs["dateFilterRef"] &&
                        this.$refs["dateFilterRef"].close
                    ) {
                        this.$refs["dateFilterRef"].close();
                    } else if (
                        this.$refs["dateFilterRef"] &&
                        this.$refs["dateFilterRef"].$el
                    ) {
                        const el =
                            this.$refs["dateFilterRef"].$el.querySelector(
                                "input",
                            ) || this.$refs["dateFilterRef"].$el;
                        if (el && el.blur) el.blur();
                    }
                    this.$refs["compRef"].openModal();
                });
            } else {
                this.selectedDate = e;
                this.fetchTotalCommissionValue().then(() => {
                    if (
                        this.$refs["dateFilterRef"] &&
                        this.$refs["dateFilterRef"].close
                    ) {
                        this.$refs["dateFilterRef"].close();
                    }
                });
            }
        },
        changeDateFilter1(e) {
            if (e.value === "Custom") {
                this.prevSelectedDate1 = { ...this.selectedDate1 };
                this.selectedDate1 = this.prevSelectedDate1;
                this.$nextTick(() => {
                    if (
                        this.$refs["dateFilterRef1"] &&
                        this.$refs["dateFilterRef1"].close
                    ) {
                        this.$refs["dateFilterRef1"].close();
                    } else if (
                        this.$refs["dateFilterRef1"] &&
                        this.$refs["dateFilterRef1"].$el
                    ) {
                        const el =
                            this.$refs["dateFilterRef1"].$el.querySelector(
                                "input",
                            ) || this.$refs["dateFilterRef1"].$el;
                        if (el && el.blur) el.blur();
                    }
                    this.$refs["compRef1"].openModal();
                });
            } else {
                this.selectedDate1 = e;
                this.fetchCommissionVsOrderValue().then(() => {
                    if (
                        this.$refs["dateFilterRef1"] &&
                        this.$refs["dateFilterRef1"].close
                    ) {
                        this.$refs["dateFilterRef1"].close();
                    }
                });
            }
        },
        changeDateFilter2(e) {
            if (e.value === "Custom") {
                this.prevSelectedDate2 = { ...this.selectedDate2 };
                this.selectedDate2 = this.prevSelectedDate2;
                this.$nextTick(() => {
                    if (
                        this.$refs["dateFilterRef2"] &&
                        this.$refs["dateFilterRef2"].close
                    ) {
                        this.$refs["dateFilterRef2"].close();
                    } else if (
                        this.$refs["dateFilterRef2"] &&
                        this.$refs["dateFilterRef2"].$el
                    ) {
                        const el =
                            this.$refs["dateFilterRef2"].$el.querySelector(
                                "input",
                            ) || this.$refs["dateFilterRef2"].$el;
                        if (el && el.blur) el.blur();
                    }
                    this.$refs["compRef2"].openModal();
                });
            } else {
                this.selectedDate2 = e;
                this.fetchSellerWiseCommission().then(() => {
                    if (
                        this.$refs["dateFilterRef2"] &&
                        this.$refs["dateFilterRef2"].close
                    ) {
                        this.$refs["dateFilterRef2"].close();
                    }
                });
            }
        },

        calcDateData(val) {
            var data = {};
            if (val == "Custom") {
                data.fromDate = this.cFromDate;
                data.toDate = this.cToDate;
            } else {
                data.fromDate = moment()
                    .subtract(val, "days")
                    .format("YYYY-MM-DD");
                data.toDate = moment().format("YYYY-MM-DD");
            }
            return data;
        },
        async fetchTotalCommissionValue() {
            const data = [
                {
                    key: "total-orders-value",
                    variables: {
                        ...this.calcDateData(this.selectedDate.value),
                        tenant: this.userId,
                    },
                },
                {
                    key: "total-commission-value",
                    variables: {
                        ...this.calcDateData(this.selectedDate.value),
                        tenant: this.userId,
                    },
                },
            ];
            const fetchedData = await this.$store.dispatch(
                "partner/fetchBulkAnalyticReport",
                {
                    items: data,
                },
            );
            try {
                this.totalCommission = Math.abs(
                    Math.trunc(
                        Number(
                            fetchedData["total-commission-value"]["amount"] ||
                                0,
                        ),
                    ),
                );
                this.orderCount =
                    fetchedData["total-orders-value"]["no_of_orders"];
                this.orderValue = Math.trunc(
                    Number(
                        fetchedData["total-orders-value"]["total_order_value"],
                    ),
                );
            } catch (error) {
                console.log(error);
            }
        },
        async fetchCommissionVsOrderValue() {
            const data = [
                {
                    key: "total-collected-commission-graph",
                    variables: {
                        ...this.calcDateData(this.selectedDate1.value),
                        tenant: this.userId,
                    },
                },
                {
                    key: "total-order-value-graph",
                    variables: {
                        ...this.calcDateData(this.selectedDate1.value),
                        tenant: this.userId,
                    },
                },
            ];
            await this.$store.dispatch("partner/fetchChart", {
                items: data,
            });
        },
        findCustomDate(val) {
            this.cFromDate = val.fromDate;
            this.cToDate = val.toDate;
            this.selectedDate = { text: "Custom", value: "Custom" };
            this.fetchTotalCommissionValue().then(() => {
                this.$nextTick(() => {
                    if (
                        this.$refs["dateFilterRef"] &&
                        this.$refs["dateFilterRef"].close
                    ) {
                        this.$refs["dateFilterRef"].close();
                    } else if (
                        this.$refs["dateFilterRef"] &&
                        this.$refs["dateFilterRef"].$el
                    ) {
                        const el =
                            this.$refs["dateFilterRef"].$el.querySelector(
                                "input",
                            ) || this.$refs["dateFilterRef"].$el;
                        if (el && el.blur) el.blur();
                    }
                });
            });
        },
        findCustomDate1(val) {
            this.cFromDate = val.fromDate;
            this.cToDate = val.toDate;
            this.selectedDate1 = { text: "Custom", value: "Custom" };
            this.fetchCommissionVsOrderValue().then(() => {
                this.$nextTick(() => {
                    if (
                        this.$refs["dateFilterRef1"] &&
                        this.$refs["dateFilterRef1"].close
                    ) {
                        this.$refs["dateFilterRef1"].close();
                    } else if (
                        this.$refs["dateFilterRef1"] &&
                        this.$refs["dateFilterRef1"].$el
                    ) {
                        const el =
                            this.$refs["dateFilterRef1"].$el.querySelector(
                                "input",
                            ) || this.$refs["dateFilterRef1"].$el;
                        if (el && el.blur) el.blur();
                    }
                });
            });
        },
        findCustomDate2(val) {
            this.cFromDate = val.fromDate;
            this.cToDate = val.toDate;
            this.selectedDate2 = { text: "Custom", value: "Custom" };
            this.fetchSellerWiseCommission().then(() => {
                this.$nextTick(() => {
                    if (
                        this.$refs["dateFilterRef2"] &&
                        this.$refs["dateFilterRef2"].close
                    ) {
                        this.$refs["dateFilterRef2"].close();
                    } else if (
                        this.$refs["dateFilterRef2"] &&
                        this.$refs["dateFilterRef2"].$el
                    ) {
                        const el =
                            this.$refs["dateFilterRef2"].$el.querySelector(
                                "input",
                            ) || this.$refs["dateFilterRef2"].$el;
                        if (el && el.blur) el.blur();
                    }
                });
            });
        },
        async fetchSellerWiseCommission() {
            let datakey = "tenant-commission-report";
            const data = [
                {
                    key: "tenant-commission-report",
                    variables: {
                        ...this.calcDateData(this.selectedDate2.value),
                        tenant: this.userId,
                    },
                },
            ];
            if (this.selectedSeller.value !== "All Seller") {
                data[0].variables.userId = this.selectedSeller.value;
                data[0].key = "seller-wise-commission-report";
                datakey = "seller-wise-commission-report";
            }
            let fetchedData = await this.$store.dispatch(
                "partner/fetchBulkAnalyticReport",
                {
                    items: data,
                },
            );

            this.items = fetchedData[datakey];
        },
    },
    async mounted() {
        await this.fetchTotalCommissionValue();
        await this.fetchCommissionVsOrderValue();
        await this.fetchSellerWiseCommission();
    },
};
</script>

<style scoped>
.head-text {
    margin-bottom: 0px;
    font-size: 1.125rem;
    font-weight: 600;
    color: #000000;
}

.select-background-white {
    background-color: #fff;
}

.chart-container {
    position: relative;
    height: 400px;
    width: 100%;
}

@media (max-width: 768px) {
    .chart-container {
        height: 300px;
    }
}
</style>
